import i18n from "i18next";

const TRANSACTION_DISPLAY_NAMES = {
    "royal first step deposit": {
        key: "global:royalAudioDeposit",
        fallback: "Royal Audio Deposit",
    },
    "wealth building challenge": {
        key: "global:wealthBuildingAudioDeposit",
        fallback: "Wealth Building Audio Deposit",
    },
};

/**
 * Display-only rename. The stored transaction description still comes from the API.
 */
export function displayTransactionName(name) {
    if (typeof name !== "string") return name;
    const replacement = TRANSACTION_DISPLAY_NAMES[name.trim().toLowerCase()];
    if (!replacement) return name;
    const translated = i18n.t(replacement.key);
    if (!translated || translated === replacement.key) {
        return replacement.fallback;
    }
    return translated;
}
